// extracted by mini-css-extract-plugin
export default {"sections":"ContentUI_sections__UqH7E"};